import { createSelector } from 'reselect';
import { initProductOptions } from 'yoda-site-components/lib/selectors/ProductOptionsSelector';

export default createSelector([initProductOptions(false)], (productOptions) => {
    if (
        productOptions &&
        productOptions.filteredItems &&
        productOptions.filteredItems.length === 1
    ) {
        return productOptions.filteredItems[0].id;
    }
    return null;
});
